import { useQuery } from "@tanstack/react-query"
import { getOrganizationQuery } from "../lib/getOrganizationQuery"

export function useGetOrganizationQuery() {
  return useQuery(getOrganizationQuery())
}
